import GetDynamicFormDefinitionRequestModelBase from '../_generated/modelBases/get-dynamic-form-definition-request-model-base';

export default class GetDynamicFormDefinitionRequestModel extends GetDynamicFormDefinitionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
